import { Theme } from "@mui/material";

const documentsStyle = {
  inlineHintBox: {
    margin: "0 auto 40px auto",
    maxWidth: "700px",
    textAlign: "left",
    "& h6": {
      marginBottom: "20px",
    },
  },
  headline: (theme: Theme) => ({
    fontWeight: 500,
    color: theme.palette.text.primary,
  }),
};

export default documentsStyle;
